import { message } from 'antd';

// TODO considerare se ancora necessario
export function showSuccessApplyMessage(
  result: 'updated' | 'added',
  options: { onUpdate: string; onAdd: string },
) {
  message.success(result === 'updated' ? options.onUpdate : options.onAdd);
}
